<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.standardNode')"
    >
      <BasiceLayout title="业务验收结果">
        <div class="hardware-content">
          <!-- 业务验收结果 -->          
          <div class="margin-20 display-flex">
            <el-tooltip class="item" effect="dark" content="目前只支持F任务" placement="bottom">
            <el-input
              v-model="searchmac"
              placeholder="输入要搜索的主机名"
              style="max-width: 200px"
            ></el-input>
            </el-tooltip>
              <div
                class="button"
                @click="search"
              >搜索</div>
          </div>
          <el-table
            :data="resultList.slice((currentPage-1)*pageSize,currentPage*pageSize)"
            align="center"
            empty-text="无"
            style="width: 100%;margin-bottom: 20px;"
          >
            <el-table-column
              prop="MuhuaMac"
              label="mac"
              align='center'
            >
            </el-table-column>
            <el-table-column
              prop="Line"
              label="线路名称"
              align='center'
            >
            </el-table-column>
            <el-table-column
              prop="CheckTaskEndTime"
              label="线路验收结束时间"
              align='center'
            >
            </el-table-column>
            <el-table-column
              prop="CheckDetailResult"
              label="线路验收结果"
              align='center'
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total"
            align="center">
          </el-pagination>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { Message } from "element-ui";
import Layout from "@/components/DatePanel/Layout.vue";

export default {
  name: "home",
  components: {
    BasiceLayout,
    Layout
  },
  data() {
    return {
      searchmac:'',
      resultList:[],
      currentPage:1,
      pageSize:20,
      total:''
    }
  },
  methods: {
    ...mapActions([ 'getTaskAcceptanceRes' ]),
    search() {
      if(!this.searchmac){
        Message({
          type:'error',
          message:'要搜索的主机名不能为空'
        })
      }else{
        let hostname = this.searchmac;
        this.getTaskAcceptanceRes({ hostname }).then(res=>{
          if(res && res.code == 200 && !res.dev_err_list.length == 0){
            this.resultList = res.dev_err_list;
            this.total = res.dev_err_list.length;
            Message({
              type:'success',
              message:'搜索成功'
            })
          }else if(res.code == 200 && res.dev_err_list.length == 0 ){
            Message({
              type:'error',
              message:'搜索数据为空'
            })
          }else{
            Message({
              type:'error',
              message:res.err_msg,
            })
          }
        })
        this.searchmac = "";
      }
    },
    handleCurrentChange(val){
      this.currentPage = val;
    }
  }
}
</script>
